import { SVGProps, Ref, forwardRef } from 'react';

export const PenFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="m9.425 2.436 1.078-1.079a2.927 2.927 0 1 1 4.14 4.14l-1.079 1.078z" fill="currentColor" />
                <path d="M8.435 3.426.5 11.361v4.14h4.14l7.934-7.936z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
PenFilledSize16Glyph.displayName = 'PenFilledSize16Glyph';
